import { useTranslation } from 'next-i18next';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { formatUTCDate } from '../../../../../services/helper';
import VyNoData from '../../../../common/VyNoData';
import { MessagingVcard } from './vcard/MessagingVcard';

const MessagingContactshares = () => {
  const { t } = useTranslation();
  const messagingContactshares = useSelector(({ common }) => common.messagingContactshares);
  const user = useSelector(({ common }) => common.user);
  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full h-16 py-8 px-4 flex flex-row justify-between items-center shadow-sm sticky z-10">
        <p className="text-xl font-bold">{t('event:messaging.contactshares-histroy')}</p>
      </div>
      <div className="flex flex-col p-4 w-full">
        {messagingContactshares.length < 1 && <VyNoData noDataText={t('event:messaging.contactshares-histroy-no-data')} />}
        {messagingContactshares.map((message) => {
          if (!message.sender || !message.recepient) return null;
          const isOwn = message.sender._id === user?._id;
          return (
            <div className="flex flex-col mb-2">
              <span className="mb-1 font-bold">{`${formatUTCDate(new Date(message.datetime_created), 'dd.MM.yyyy HH:mm')} - ${message.sender.name} > ${
                message.recepient.name
              }`}</span>
              <MessagingVcard attendee={message.sender} message={message._id} isOwn={isOwn} />
              <hr className="m-4" />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default MessagingContactshares;
